import { Component, OnInit, NgZone } from "@angular/core";
import { JSScript, ScriptService } from "../../services/script.service";

@Component({
  selector: "celine-script",
  template: ``,
})
export class CelineScriptComponent implements OnInit {
  constructor (private ngZone: NgZone, private scriptService: ScriptService) { }

  ngOnInit() {
    if (window.location.href.indexOf("#/widget-frame?") === -1) {
      this.scriptService.getAPIScripts().subscribe(
        (next: JSScript[]) => {
          if (next) {
            this.scriptService.processScripts(next);
            this.ngZone.runOutsideAngular(() => {
              this.scriptService.processRUM()
            });
          }
        },
        (error) => {
          console.log("@celine: Error occurred loading scripts - " + error);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/script/celine-script.component.ts